import React from 'react'
import FormRichiestaAttivazione from '../../components/organisms/FormRichiestaAttivazione/FormRichiestaAttivazione'
import { PAGINEDETAIL } from '../../utils/endpoint'
import { getApiClient } from '../../utils'
import PropTypes from 'prop-types'

const RichiestaAttivazione = ({ page }) => {
  return (
    <>
      <FormRichiestaAttivazione page={page} />
    </>
  )
}

export async function getServerSideProps({ locale, req }) {
  const api = getApiClient(req)
  try {
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'richiesta-attivazione',
        lang: locale,
      },
    })
    const page = await pageResponse.data

    const toolbarProps = { toolbarPage: page }

    return { props: { page, ...toolbarProps } }
  } catch (error) {
    return {
      notFound: true,
    }
  }
}

RichiestaAttivazione.propTypes = {
  page: PropTypes.object,
}

export default RichiestaAttivazione
